import React from 'react';
import { ControlLabel, FormControl, FormGroup, Panel } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select-plus';



const SearchForm = ({ form, onFormUpdate }) => (
  <Panel defaultExpanded>
    <Panel.Toggle componentClass={Panel.Heading}>
      <Panel.Title toggle>
        <FontAwesome name="search" /> Search Employees
      </Panel.Title>
    </Panel.Toggle>
    <Panel.Collapse>
      <Panel.Body>
        <FormGroup>
          <ControlLabel>Name / Number</ControlLabel>
          <FormControl  id="employee_search" name="employee_search" onChange={(e) => onFormUpdate({ query: e.target.value })} value={form.query || ''} />
        </FormGroup>
     
      </Panel.Body>
    </Panel.Collapse>
  </Panel>
);

export default SearchForm;
